<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { getColor } from '$lib/helper';

    import DividerView from './Divider.View.svelte';

    import type { DividerContent } from '$lib/types/Components/Divider/DividerContent';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';

    export let theme: Theme;
    export let content: DividerContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout = DEFAULT_LAYOUT;
</script>

<DividerView
    box={content.box}
    hidden={content.hidden}
    dashed={content.dashed}
    size={content.size}
    color={getColor(content.color, theme.fontColor)}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
